import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrintBulkVehicleRoutingModule } from './print-bulk-vehicle-routing.module';
import { BulkVehicleDetailsComponent } from './bulk-vehicle-details/bulk-vehicle-details.component';
import { BulkVehicleLinkComponent } from './bulk-vehicle-link/bulk-vehicle-link.component';
import { BulkVehicleLandingComponent } from './bulk-vehicle-landing/bulk-vehicle-landing.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';


@NgModule({
  declarations: [
    BulkVehicleDetailsComponent,
    BulkVehicleLinkComponent,
    BulkVehicleLandingComponent
  ],
  imports: [
    CommonModule,
    PrintBulkVehicleRoutingModule,
    AcademicFormModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule
  ]
})
export class PrintBulkVehicleModule { }
